import { boot } from "quasar/wrappers";
import VueLogger from "vuejs3-logger";

export default boot(({ app }) => {
  const options = {
    isEnabled: true,
    stringifyArguments: false,
    showLogLevel: true,
    showMethodName: true,
    separator: "|",
    showConsoleColors: true,
  };

  app.use(VueLogger, options);
});
